// Request headers for direct PostgREST calls.
//
// The distinction that matters: `apikey` identifies the *project*, the
// `Authorization` Bearer identifies the *user*. Sending the anon key as Bearer
// leaves auth.uid() NULL server-side, so every RLS policy of the form
// `auth.uid() = user_id` rejects the row — PostgREST answers 401 with
// "42501: new row violates row-level security policy".
//
// That is exactly how league table tips silently broke: they wrote with the
// anon key, which worked until Migration 018 switched RLS on for tips_v2.
// Reads of public tables (leagues, standings) are fine with the anon key —
// only writes and user-scoped reads need the session token.

const PROJECT_REF = "fvuwfonfrllbjqvywula";

/** Where supabase-js keeps the session. */
export const SESSION_STORAGE_KEY = `sb-${PROJECT_REF}-auth-token`;

/**
 * The signed-in user's access token, or null when signed out.
 * Tolerates both the current and the legacy session shape, and never throws
 * on malformed storage.
 */
export function getAccessToken(): string | null {
  try {
    const raw = localStorage.getItem(SESSION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.access_token ?? parsed?.currentSession?.access_token ?? null;
  } catch {
    return null;
  }
}

/**
 * Headers carrying the user's identity. Pass the project's anon key; it is
 * used for `apikey` and as Bearer fallback when nobody is signed in.
 */
export function authedHeaders(anonKey: string): Record<string, string> {
  return {
    apikey: anonKey,
    Authorization: `Bearer ${getAccessToken() ?? anonKey}`,
    "Content-Type": "application/json",
  };
}
